export default __webpack_public_path__ + "static/media/icon-pencil.8a4589da.svg";